exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.login-card[data-v-0d19e505] {\n  background: url('/images/bg_foot.jpg');\n  height: 340px;\n}\n", ""]);

// exports
